import block from './block.json';

export const categoriesFilterThemeAttributes = {
	margin: {
		top: [20, 40],
		bottom: [20, 40],
	},
	grid: {
		gap: [10, 10],
	},
};

export const CategoriesFilterThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: categoriesFilterThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
